import React from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Table, TableRow, TableCell, TableBody, TableHead} from "@mui/material";

export default function Passenger(props){
  return (
    <div>
      <Accordion disabled={props.disabled}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          >
          <Typography>{props.name}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Table>
            <TableHead>Flights{props.departRoute === "" ? " -no flights required": ""
            }</TableHead>
            {props.departRoute === "" ?
            "" :
            <TableBody>
              <TableRow>
                <TableCell>Depart</TableCell>
                <TableCell>{props.departRoute} on {props.departDate}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Return</TableCell>
                <TableCell>{props.returnRoute} on {props.returnDate}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Preferred Flight Time</TableCell>
                <TableCell>{props.prefTime}</TableCell>
              </TableRow>
            </TableBody>
            }
          </Table>
          {props.groundTravel === "" ?
           "" : 
          <Table>
            <TableHead>
              Ground Travel
            </TableHead>
            <TableRow>
              <TableCell>
                {props.groundTravel}
              </TableCell>
            </TableRow>
          </Table>
          }
           {props.accom === "" ?
           "" : 
          <Table>
            <TableHead>
              Accommodation
            </TableHead>
            <TableRow>
              <TableCell>
                {props.accom}
              </TableCell>
            </TableRow>
          </Table>
          }
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>Full Name</TableCell>
                  <TableCell>{props.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Date of Birth</TableCell>
                  <TableCell>{props.dob}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>ID Number</TableCell>
                  <TableCell>{props.id}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Email Address</TableCell>
                  <TableCell>{props.email}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Contact Number</TableCell>
                  <TableCell>{props.phone}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Role</TableCell>
                  <TableCell>{props.role}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
        </AccordionDetails>
      </Accordion></div>
  )
}